<app-header [isHome]=false [isInmuebles]="true"></app-header>

<section id="inmuebles-detalle-1" class="bg-light reset-section-pad">

  <div class="container">

    <div class="row">
      <div class="col-lg-12 datos-inmue">
        <div class="col-lg-12 col-md-12 col-sm-12 det-inmue">

          <a class="" (click)="gotBackToPropertiesMain()">
            <div class="det-inmue-back-map"><img src="assets/img/inmuebles/flecha_1.svg" class="" width="10"
                alt="indicador volver atrás" /></div>
          </a>
          <div class="det-inmue-nomb">
            <h1 class="tit-inmueble fw-bolder" *ngIf="prop?.name; else fakeNameTemplate">{{prop?.name}}</h1>
            <ng-template #fakeNameTemplate>
              <h1 class="tit-inmueble fw-bolder">{{fakeName}}</h1>
            </ng-template>
            <div class="det-inmue-nomb-inner"><img src="assets/img/inmuebles/localizador_1.svg" width="10"
                alt="localización" />
              <p>{{prop?.address}}</p>
            </div>
          </div>


        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 mx-auto px-0">
        <div id="carousel5" class="carousel slide carousel-fade carouselTipo2" data-bs-ride="carousel">
          <div *ngIf="prop?.images.length; else imgsFake" class="carousel-inner">
            <div class="carousel-item" *ngFor="let item of prop?.images; index as i" [ngClass]="{'active': i==0}">
              <img src="https://{{item.location}}" class="d-block img-full-cover" alt="{{item.alt}}">
            </div>

            <span *ngIf="generatedComment == 'Alquilado'" class="local_mark_listing-int">
              <img src="assets/img/local_rented.png" alt="Local alquilado" class="img_mark_listing img-full-cover">
            </span>
            <span *ngIf="generatedComment == 'Vendido'" class="local_mark_listing-int">
              <img src="assets/img/local_sold.png" alt="Local vendido" class="img_mark_listing img-full-cover">
            </span>
          </div>

          <ng-template #imgsFake>
            <div class="carousel-inner" *ngIf="!prop?.thumbnail && loaded">
              <div class="carousel-item active">

                <span *ngIf="generatedComment == 'Alquilado' || generatedComment == 'Vendido'; else available">
                  <img *ngIf="generatedComment == 'Alquilado'" src="assets/img/local_rented.jpg"
                    class="img-fluid rounded-start img-full-cover" alt="imagen principal inmueble">
                  <img *ngIf="generatedComment == 'Vendido'" src="assets/img/local_sold.jpg"
                    class="img-fluid rounded-start img-full-cover" alt="imagen principal inmueble">
                </span>
                <ng-template #available>
                  <img *ngIf="loaded" src="assets/img/inmuebles/ejemplo4.jpg"
                    class="img-fluid rounded-start img-full-cover" alt="imagen principal inmueble">
                </ng-template>
              </div>
            </div>
          </ng-template>

          <div class="controls bg-light">
            <div class="controls-blq" *ngIf="prop?.images?.length! > 1">
              <button class="carousel-control-prev" type="button" data-bs-target="#carousel5" data-bs-slide="prev">
                <span class="carousel-control-prev-icon prueba" aria-hidden="true"></span>
                <span class="visually-hidden">Previo</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carousel5" data-bs-slide="next">
                <span class="carousel-control-next-icon prueba" aria-hidden="true"></span>
                <span class="visually-hidden">Siguiente</span>
              </button>
            </div>
          </div>
        </div><!-- fin carousel-->
      </div>
    </div>


    <div class="row">

      <div class="col-lg-12 inmue-content">

        <div class="col-lg-8 col-md-12 col-sm-12 col-12 inmue-content-blq1">

          <div class="col-lg-12 col-md-12 col-sm-12 col-12 datos-clave bg-grey mb-5">
            <h3 class="fw-bold">{{prop?.surfaceTotal}}m<sup>2</sup></h3>
            <h3 class="fw-bold" *ngIf="prop?.priceVisible">

              {{prop?.askingPriceRent | number: '1.0-0'}}€/mes</h3>
            <h3 *ngIf="prop?.smokeStractor" class="fw-bold">Salida de humos</h3>

          </div><!-- fin datos clave-->

          <div class="col-lg-12 col-md-12 col-sm-12 col-12 inmue-content-blq1-inner1 bg-light">
            <h1>{{generatedName}}</h1>
            <p>Cod: {{prop?.id_ext}}</p>
            <div class="mb-3">&nbsp;</div>
            <p *ngIf="prop?.descLong; else fakeDescription" [innerHTML]="prop?.descLong"></p>
            <ng-template #fakeDescription>
              <p [innerHTML]="fakeDesc"></p>
            </ng-template>
          </div><!-- fin descripción-->



        </div>

        <div class="col-lg-4 col-md-12 col-sm-12 col-12 inmue-content-blq2 rco">
          <div class="col-12 inmue-content-blq2-inner1">
            <h3 class="fw-bold">¿quieres más información?</h3>
          </div>
          <div class="col-12 inmue-content-blq2-inner2 bg-rco">
            <h3 class="light fw-bold"><a href="#" class="light" data-bs-toggle="modal"
                data-bs-target="#ModalContact">Contactar</a></h3>
          </div>

        </div>
      </div>

      <div class="col-lg-10 col-md-12 col-sm-12 col-12 inmue-content-blq1-inner1 ">
        <h1 class="mb-2">Detalles</h1>

        <div class="row">
          <div class="col-12 d-flex flex-wrap">
            <div class="col-lg-4 col-md-6 col-sm-6 col-12 py-3 px-0" *ngIf="prop?.surfaceTotal!='0'">
              Superficie total: <strong>{{prop?.surfaceTotal}} m<sup>2</sup></strong>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-12 py-3 px-0" *ngIf="prop?.surfacepb!='0'">
              Superficie Planta baja: <strong>{{prop?.surfacepb}} m<sup>2</sup></strong>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-12 py-3 px-0" *ngIf="prop?.surfacebr!='0'">
              Superficie bajo rasante: <strong>{{prop?.surfacebr}} m<sup>2</sup></strong>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 col-12 py-3 px-0" *ngIf="prop?.surfaceMezzanine!='0'">
              Superficie entresuelo: <strong>{{prop?.surfaceMezzanine}} m<sup>2</sup></strong>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-12 py-3 px-0" *ngIf="prop?.surfaceBasement1!='0'">
              Superficie Planta 1: <strong>{{prop?.surfaceBasement1}} m<sup>2</sup></strong>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-12 py-3 px-0" *ngIf="prop?.surfaceBasement2!='0'">
              Superficie Planta 2: <strong>{{prop?.surfaceBasement2}} m<sup>2</sup></strong>
            </div>
          </div>
        </div>


      </div>




      <!-- <div class="col-lg-10 col-md-12 col-sm-12 col-12 inmue-content-blq1-inner1 ">
            <h1 class="mb-2">Características</h1>
              <div class="row">
                <div class="col-12 d-flex flex-wrap">
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 py-3 px-0">
                    <i class="fa fa-door-open me-2"></i>Estancias: <strong>4</strong>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 py-3 px-0">
                    <i class="fa fa-bath me-2"></i>Baños: <strong>2</strong>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 py-3 px-0">
                    <i class="fa fa-parking me-2"></i>Parking: <strong>NO</strong>
                  </div>

                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 py-3 px-0">
                    <i class="fa fa-snowflake me-2"></i>Aire acondicionado: <strong>SI</strong>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 py-3 px-0">
                    <i class="fa fa-door-closed me-2"></i>Trastero: <strong>SI</strong>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 py-3 px-0">
                    <i class="fa fa-house-user me-2"></i>Terraza: <strong>NO</strong>
                  </div>
                </div>
              </div>

    </div>  -->




    </div>


  </div>

</section>




<section *ngIf="prop?.video" id="inmuebles-detalle-2" class="bg-grey">

  <div class="container">
    <div class="row">



      <div class="col-lg-12">

        <h1>Video del inmueble</h1>

        <div class="col-lg-12 col-md-12 col-sm-12 col-12 video-blq-inm">

          <iframe [src]="urlVideoSafe" width="920" height="600" title="retailCo. Damos vida a los locales"
            frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

        </div>

      </div>

    </div>
  </div>


</section>





<section id="inmuebles-detalle-3" class="bg-light">

  <div class="container">
    <div class="row">

      <div class="col-lg-12 mapa">
        <h1>Ubicación</h1>
        <div class="mapouter">
          <div class="gmap_canvas">
            <div id='detailMap' class="mainMap"></div>
          </div>
        </div>

      </div>

    </div>
  </div>

</section>




<!-- Modal  formulario contacto-->
<form autocomplete="off" [formGroup]="contactForm" (ngSubmit)="sendContact()">
  <div class="modal fade modalcontact" id="ModalContact" tabindex="-1" aria-labelledby="ModalContact"
    aria-hidden="true">
    <div class="modal-dialog w800 modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title fw-bold" id="exampleModalLabel">Pregúntanos sobre este inmueble</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" *ngIf="formVisible">

          <div class="mb-3">
            <label for="recipient-name" class="col-form-label">* Nombre y apellidos</label>
            <input formControlName="name" type="text" class="form-control" id="recipient-name" [class.valid]="contactForm.get('name')!.valid && 
                (contactForm.get('name')!.dirty || contactForm.get('name')!.touched)" [class.invalid]="contactForm.get('name')!.invalid && 
                (contactForm.get('name')!.dirty || contactForm.get('name')!.touched)" required>
            <small class="text-secondary" *ngIf="contactForm.get('name')!.hasError('required')">
              Por favor, introduce tu nombre y apellidos
            </small>
            <small class="text-secondary" *ngIf="contactForm.get('name')!.hasError('minlenght')">
              Por favor, introduce correctamente tu nombre y apellidos
            </small>

          </div>

          <div class="mb-3">
            <label for="recipient-phone" class="col-form-label">* Teléfono</label>
            <input formControlName="phone" type="tel" class="form-control" id="recipient-phone" [class.valid]="contactForm.get('phone')!.valid && 
                (contactForm.get('phone')!.dirty || contactForm.get('phone')!.touched)" [class.invalid]="contactForm.get('name')!.invalid && 
                (contactForm.get('phone')!.dirty || contactForm.get('phone')!.touched)">
            <small class="text-secondary" *ngIf="contactForm.get('phone')!.hasError('required')">
              Por favor, introduce un teléfono de contacto
            </small>
            <small class="text-danger" *ngIf="contactForm.get('phone')!.hasError('pattern')">
              Por favor, introduce un teléfono de contacto válido
            </small>
            <small class="text-danger" *ngIf="contactForm.get('phone')!.hasError('minlenght')">
              Por favor, introduce un teléfono de contacto válido
            </small>
            <small class="text-danger" *ngIf="contactForm.get('phone')!.hasError('maxlenght')">
              Por favor, introduce un teléfono de contacto válido
            </small>
          </div>
          <div class="mb-3">
            <label for="recipient-email" class="col-form-label">* Email</label>
            <input formControlName="email" type="email" class="form-control" id="recipient-email" [class.valid]="contactForm.get('email')!.valid && 
                (contactForm.get('email')!.dirty || contactForm.get('email')!.touched)" [class.invalid]="contactForm.get('email')!.invalid && 
                (contactForm.get('email')!.dirty || contactForm.get('email')!.touched)" required>
            <small class="text-secondary" *ngIf="contactForm.get('email')!.hasError('required')">
              Por favor, introduce un email de contacto
            </small>
            <small class="text-danger" *ngIf="contactForm.get('email')!.hasError('email')">
              Por favor, introduce un email de contacto válido
            </small>
          </div>

          <div class="mb-3">
            <label for="message-text" class="col-form-label">* Mensaje</label>
            <textarea formControlName="message" class="form-control" id="message-text" [class.valid]="contactForm.get('message')!.valid && 
                (contactForm.get('message')!.dirty || contactForm.get('message')!.touched)" [class.invalid]="contactForm.get('message')!.invalid && 
                (contactForm.get('message')!.dirty || contactForm.get('message')!.touched)"
              required>Hola, estoy interesado en este inmueble.</textarea>
            <small class="text-secondary" *ngIf="contactForm.get('message')!.hasError('required')">
              Por favor, introduce tu mensaje
            </small>
          </div>
          <div>
            <ul class="fs-6 list-group list-group-flush mb-2">
              <li class="list-group-item"><small><b>Responsable:</b> Retailcompany 2021, S.L.</small></li>
              <li class="list-group-item"><small><b>Finalidades:</b> Atender y gestionar su solicitud, así como
                  comunicar sus datos al propietario o gestor comercial del inmueble para concertar una visita. En caso
                  de que preste su consentimiento, para remitirle comunicaciones comerciales propias y de terceras
                  empresas relacionadas con productos y/o servicios inmobiliarios y financieros.</small></li>
              <li class="list-group-item"><small><b>Derechos:</b> Puede ejercer sus derechos en <a
                    href="mailto:privacidad1@retailco.es">privacidad1&#64;retailco.es</a> y acceder a más información
                  sobre el tratamiento de sus datos personales.</small></li>
            </ul>
          </div>
          <div class="form-check mb-2">
            <input formControlName="privacy" class="form-check-input" type="checkbox" value="" id="pol-privacidad">
            <label class="form-check-label" for=""><small>
                * Acepto la <a (click)="privacy()" [ngClass]="{ 'blink_me': privacy_tip }"><u>política de protección de
                    datos</u></a></small>
            </label>
          </div><!-- fin checkbox-->
          <div class="form-check mb-2">
            <!-- <input formControlName="consent" class="form-check-input" type="checkbox" value="" id="pol-consent">
            <label class="form-check-label" for="pol-privacidad"><small>
                Consiento que Retailco utilice mis datos para remitirme comunicaciones comerciales propias y de terceras
                empresas relacionadas con productos y/o servicios inmobiliarios y financieros.</small>
            </label> -->
          </div><!-- fin checkbox-->


        </div>
        <div class="modal-footer">

          <div *ngIf="privacy_tip">Debes hacer click en el enlace y revisar la política de protección de datos.</div>
          <div *ngIf="formResponse" [innerHTML]="formResponse"></div>
          <div disabled-wrapper (mouseover)="privacyAlert()" (mouseleave)="privacyAlertExit()">
            <button class="btn btn-search bradius-r" type="submit" [disabled]="contactForm.invalid || !privacyActive"
              [ngClass]="{ 'disabled': contactForm.invalid }" *ngIf="formVisible">Enviar</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</form>



<app-footer-main></app-footer-main>